
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"34","height":"34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Grupo 1014"}},[_c('g',{attrs:{"data-name":"Grupo 988"}},[_c('rect',{attrs:{"data-name":"Rectángulo 763","width":"34","height":"34","rx":"17","fill":"#f1f1f1"}})]),_c('g',{attrs:{"data-name":"Grupo 592"}},[_c('g',{attrs:{"data-name":"Grupo 280","transform":"translate(8.771 10.655)","fill":"none","stroke":"#a9b2ba","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"data-name":"Trazado 165","d":"M0 6.345s2.191 6.209 8.468 6.344c0 0 5.771.21 7.989-6.344"}}),_c('path',{attrs:{"data-name":"Trazado 166","d":"M0 6.346S2.191.133 8.468.001c0 0 5.771-.21 7.989 6.344"}}),_c('circle',{attrs:{"data-name":"Elipse 33","cx":"2.805","cy":"2.805","transform":"translate(5.476 3.554)","r":"2.805"}})])])])])
          )
        }
      }
    